import OffDays from './OffDays';
import { useState } from 'react';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import WorkingHoursSection from './WorkingHourSelection';
import { BusinessScheduleProps } from '@/apis/agency/businessOnboarding/types';

export default function BusinessSchedule({
  control,
  fieldName,
  holidaysFieldName,
  getValues,
  setValue,
  showTabs = true
}: BusinessScheduleProps & { holidaysFieldName?: string }) {
  const [tab, setTab] = useState(0);

  return (
    <Box mt={4}>
      {showTabs && (
        <>
          <Typography variant='h6' mb={2} fontSize={16}>
            Schedule
          </Typography>

          <Tabs
            value={tab}
            onChange={(_, val) => setTab(val)}
            variant='fullWidth'
            sx={{
              backgroundColor: '#F8F9FA',
              borderRadius: '8px',
              '& .MuiTab-root': {
                borderRadius: '8px',
                width: '100%'
              }
            }}
          >
            <Tab label='Working Hours' />
            <Tab label='Off Days' />
          </Tabs>
        </>
      )}

      <Box mt={2}>
        {showTabs ? (
          tab === 0 ? (
            <WorkingHoursSection control={control} fieldName={fieldName} getValues={getValues} setValue={setValue} />
          ) : (
            <OffDays control={control} fieldName={holidaysFieldName} />
          )
        ) : (
          <WorkingHoursSection control={control} fieldName={fieldName} getValues={getValues} setValue={setValue} />
        )}
      </Box>
    </Box>
  );
}
